import moment from 'moment'
import { IWorkorderClockingAction } from '@cbgms/api/modules/clocking-actions'
import { apiFormat } from '@cbgms/base/utils/datetime'
import { isEmptyUUID } from '@cbgms/base/utils/uuid'

export const OTHER_REPAIRS_KEY = 'other-repairs'

export interface IClockedTime {
  seconds: number
  isActive: boolean
}

export const emptyClockedTime: IClockedTime = { seconds: 0, isActive: false }

export const isOpenClock = (clockedOutAt: string) => moment(clockedOutAt, apiFormat.iso).year() <= 1

export interface IAggregatedClockingResult {
  perItem: Record<string, IClockedTime>
  totalSeconds: number
  totalIsActive: boolean
}

export const aggregateTimePerClockingItem = (
  data: IWorkorderClockingAction[],
  serverTime: string,
  employeeUUID: string
): IAggregatedClockingResult => {
  const perItem: Record<string, IClockedTime> = {}
  let totalSeconds = 0
  let totalIsActive = false

  data
    .filter(({ Employee }) => Employee.UUID === employeeUUID)
    .forEach(({ ClockingAction }) => {
      const isActive = isOpenClock(ClockingAction.ClockedOutAt)
      const clockedOut = isActive ? serverTime : ClockingAction.ClockedOutAt
      const seconds = moment(clockedOut, apiFormat.iso).diff(moment(ClockingAction.ClockedInAt, apiFormat.iso), 'seconds')

      const key = isEmptyUUID(ClockingAction.ClockingItemUUID) ? OTHER_REPAIRS_KEY : ClockingAction.ClockingItemUUID!

      if (!perItem[key]) {
        perItem[key] = { seconds: 0, isActive: false }
      }

      perItem[key].seconds += seconds
      perItem[key].isActive = perItem[key].isActive || isActive

      totalSeconds += seconds
      totalIsActive = totalIsActive || isActive
    })

  return { perItem, totalSeconds, totalIsActive }
}
